import { h, Component } from 'preact'
import Checkboxes from './Checkboxes'
import Filters from '../components/Filters'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class Filter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      error: false,
      isLoading: false
    }
  }

  render() {
    const { filterActive } = this.props
    const activeClass = filterActive ? 'active' : ''

    // Count categories
    let categoriesCount = {}
    let countcategories = []
    let animalsCount = {}
    let countanimals = []
    let brandsCount = {}
    let countbrands = []

    this.props.allPosts.map(cat => {
      cat.product_category_name.forEach(cat => {
        countcategories.push(cat)
      })

      cat.animal_category_name.forEach(cat => {
        countanimals.push(cat)
      })

      cat.brand_category_name.forEach(cat => {
        countbrands.push(cat)
      })
    })

    countcategories.forEach(function(x) {
      categoriesCount[x] = (categoriesCount[x] || 0) + 1
    })

    countanimals.forEach(function(x) {
      animalsCount[x] = (animalsCount[x] || 0) + 1
    })

    countbrands.forEach(function(x) {
      brandsCount[x] = (brandsCount[x] || 0) + 1
    })

    return (
      <div className={`c-shop-filter ${activeClass}`}>
        <div className="c-shop-filter__filter-label u-hide-on-medium-down">
          {this.props.filterLabel}
        </div>

        <Filters
          currentCategories={this.props.currentCategories}
          currentAnimals={this.props.currentAnimals}
          currentBrands={this.props.currentBrands}
          allCategories={this.props.categories}
          allAnimals={this.props.animals}
          allBrands={this.props.brands}
          searchText={this.props.searchText}
          handleRemove={this.props.handleRemove}
          handleRemoveSearch={this.props.handleRemoveSearch}
          handleReset={this.props.handleReset}
          handleChange={this.props.handleChange}
          language={this.props.language}
        />

        <div className="c-shop-filter__filter-wrapper">
          <div className="c-shop-filter__wrapper">
            <div className="c-shop-filter__top-bar u-hide-on-large-up">
              <div className="c-shop-filter__top-bar-title">
                {this.props.filterLabel}
              </div>
              <svg
                className="c-icon c-shop-filter__filter-icon"
                onClick={this.props.handleToggle}
              >
                <use href="#close" xlinkHref="#close" />
              </svg>
            </div>

            {!this.props.startAnimal ? (
              <Checkboxes
                handleChange={this.props.handleChange}
                handleClick={this.props.handleClick}
                showMoreLabel={this.props.showMoreLabel}
                showLessLabel={this.props.showLessLabel}
                target="currentAnimals"
                items={this.props.animals}
                currentElements={this.props.currentAnimals}
                type="animals"
                title={this.props.labelAnimal}
                isLoading={this.props.isLoading}
                counter={animalsCount}
                allPosts={this.props.allPosts}
                handleClose={this.props.handleToggle}
              />
            ) : (
              false
            )}

            {!this.props.startCategory ? (
              <Checkboxes
                handleChange={this.props.handleChange}
                handleClick={this.props.handleClick}
                showMoreLabel={this.props.showMoreLabel}
                showLessLabel={this.props.showLessLabel}
                target="currentCategories"
                items={this.props.categories}
                currentElements={this.props.currentCategories}
                type="categories"
                title={this.props.labelCategory}
                isLoading={this.props.isLoading}
                counter={categoriesCount}
                allPosts={this.props.allPosts}
                handleClose={this.props.handleToggle}
              />
            ) : (
              false
            )}

            {!this.props.startBrand ? (
              <Checkboxes
                handleChange={this.props.handleChange}
                handleClick={this.props.handleClick}
                showMoreLabel={this.props.showMoreLabel}
                showLessLabel={this.props.showLessLabel}
                target="currentBrands"
                items={this.props.brands}
                currentElements={this.props.currentBrands}
                type="brand"
                title={this.props.labelBrand}
                isLoading={this.props.isLoading}
                counter={brandsCount}
                allPosts={this.props.allPosts}
                handleClose={this.props.handleToggle}
              />
            ) : (
              false
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default Filter



// WEBPACK FOOTER //
// ./src/js/shop/containers/Filter.js